<!-- キーワードから探す プルダウン -->
<template>
  <div class="crly-a-common-search-keyword-pulldown icon">
    <select
      @change="changeSelect"
      v-model="pulldown"
      class="crly-a-common-search-keyword-pulldown__phone"
      :disabled="list.length === 1"
    >
      <template v-for="(item, index) in list">
        <template v-if="item.optgroup">
          <!-- グループ化の場合 -->
          <optgroup :key="index" :label="item.name">
            <option
              v-for="(child, cIndex) in item.list"
              :key="cIndex"
              :value="child.value"
            >
              {{ child.name }}
            </option>
          </optgroup>
        </template>
        <template v-else>
          <option :key="index" :value="item.value">
            {{ item.name }}
          </option>
        </template>
      </template>
    </select>
  </div>
</template>

<script>
export default {
  name: "CrlyAtomsCommonSearchKeywordPulldown",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    kinds: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      pulldown: ""
    };
  },
  methods: {
    changeSelect() {
      let select = {};
      let pulldown = "";
      if (this.kinds === "category") {
        if (this.pulldown) {
          select = this.list.find((element) => element.value === this.pulldown);
          pulldown = select.catLrgCd;
        } else {
          pulldown = this.pulldown;
        }
      } else if (this.kinds === "prefecture") {
        let preList = [];
        this.list.forEach((element) => {
          if (element.list) preList.push(element.list);
        });
        if (this.pulldown) {
          pulldown = preList
            .flat()
            .find((element) => element.value === this.pulldown);
        } else {
          pulldown = this.pulldown;
        }
      } else {
        pulldown = this.pulldown;
      }
      this.$emit("changePulldown", pulldown);
    }
  },
  /**
   * 都道府県が変わっても、プルダウンリストに「市区町村」を表示させる
   */
  watch: {
    list(value) {
      this.$nextTick(() => {
        if (value.length > 0) {
          if (
            value[0].name === this.$t("search.keyword.municipalities") ||
            value[0].name === this.$t("search.keyword.smallCategory")
          ) {
            this.pulldown = value[0].value;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/search/keyword/pulldown.scss";
</style>
